// extracted by mini-css-extract-plugin
export default {"badge":"CountBadge-module__badge_KHRK1"};